module.exports = __webpack_public_path__ + "img/alipay-icon.73d17bc8.png";